import { render, staticRenderFns } from "./SearchResultTabsEventsFilter.vue?vue&type=template&id=2a8b5428&scoped=true&"
import script from "./SearchResultTabsEventsFilter.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsEventsFilter.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultTabsEventsFilter.vue?vue&type=style&index=0&id=2a8b5428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b5428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
